import { FilterOption } from '../types';

export const bedroomOptions: FilterOption[] = [
  { value: 'studio', label: 'Studio' },
  { value: '1', label: '1' },
  { value: '2', label: '2' },
  { value: '3', label: '3' },
  { value: '4', label: '4' },
  { value: '5+', label: '5+' },
];

export const bathroomOptions: FilterOption[] = [
  { value: '1', label: '1' },
  { value: '2', label: '2' },
  { value: '3', label: '3' },
  { value: '4', label: '4' },
  { value: '5+', label: '5+' },
];

export const quotaOptions: FilterOption[] = [
  { value: 'thai', label: 'Thai' },
  { value: 'foreigner', label: 'Foreigner' },
  { value: 'both', label: 'Both' },
];

export const statusOptionsLeft: FilterOption[] = [
  { value: 'ready_to_move', label: 'Ready to Move' },
  { value: 'under_construction', label: 'Under Construction' },
  { value: 'off_plan', label: 'Off Plan' },
];

export const statusOptionsRight: FilterOption[] = [
  { value: 'renovation_required', label: 'Renovation Required' },
  { value: 'furnished', label: 'Furnished' },
  { value: 'unfurnished', label: 'Unfurnished' },
];

export const floorOptionsLeft: FilterOption[] = [
  { value: 'ground', label: 'Ground Floor' },
  { value: 'middle', label: 'Middle Floor' },
  { value: 'high', label: 'High Floor' },
];

export const floorOptionsRight: FilterOption[] = [
  { value: 'penthouse', label: 'Penthouse' },
  { value: 'duplex', label: 'Duplex' },
  { value: 'other', label: 'Other' },
];

export const viewOptionsLeft: FilterOption[] = [
  { value: 'city', label: 'City View' },
  { value: 'sea', label: 'Sea View' },
  { value: 'mountain', label: 'Mountain View' },
  { value: 'garden', label: 'Garden View' },
];

export const viewOptionsRight: FilterOption[] = [
  { value: 'pool', label: 'Pool View' },
  { value: 'river', label: 'River View' },
  { value: 'golf', label: 'Golf View' },
  { value: 'no_view', label: 'No View' },
];

export const directionOptionsLeft: FilterOption[] = [
  { value: 'north', label: 'North' },
  { value: 'south', label: 'South' },
  { value: 'east', label: 'East' },
  { value: 'west', label: 'West' },
];

export const directionOptionsRight: FilterOption[] = [
  { value: 'northeast', label: 'Northeast' },
  { value: 'northwest', label: 'Northwest' },
  { value: 'southeast', label: 'Southeast' },
  { value: 'southwest', label: 'Southwest' },
];

export const publishedByOptions: FilterOption[] = [
  { value: 'owner', label: 'Owner' },
  { value: 'agent', label: 'Agent' },
  { value: 'developer', label: 'Developer' },
  { value: 'bank', label: 'Bank' },
];

export const postedDateOptionsLeft: FilterOption[] = [
  { value: 'today', label: 'Today' },
  { value: 'yesterday', label: 'Yesterday' },
  { value: 'last_3_days', label: 'Last 3 Days' },
];

export const postedDateOptionsRight: FilterOption[] = [
  { value: 'last_week', label: 'Last Week' },
  { value: 'last_month', label: 'Last Month' },
  { value: 'last_3_months', label: 'Last 3 Months' },
];

export const DEFAULT_EXPANDED_PANELS = new Set(['price']);

export const DEFAULT_SECTION_VISIBILITY = {
  price: true,
  bedroom: true,
  bathroom: true,
  area: true,
  quota: true,
  status: true,
  floor: true,
  view: true,
  direction: true,
  publishedBy: true,
  postedDate: true,
  distance: true,
};

export const MOCK_API_FILTERS = [
  'price',        // ช่วงราคา
  'publishedBy',  // ประกาศโดย
  'postedDate'    // ลงประกาศเมื่อ
];

export const ALL_KNOWN_FILTER_NAMES = [
  'price',
  'bedroom', 
  'bathroom',
  'area',
  'quota',
  'status',
  'floor', 
  'view',
  'direction',
  'publishedBy',
  'postedDate',
  'distance'
] as const;

export type KnownFilterName = typeof ALL_KNOWN_FILTER_NAMES[number]; 